import React, { useState } from "react";
import { useHoldingsComparisonController } from "../hooks/useHoldingsComparisonController";
import { HoldingsComparisonHeader } from "./HoldingsComparisonHeader";
import { HoldingsComparisonView } from "./HoldingsComparisonView";
import { MultiPeriodCurrencyView } from "./MultiPeriodCurrencyView";
import { ReportingPeriodTimeline } from "../../reporting-periods";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TrendingUp, GitCompare } from "lucide-react";

export const HoldingsComparison = () => {
  const controller = useHoldingsComparisonController();
  const [activeTab, setActiveTab] = useState("comparison");

  return (
    <div className="w-full">
      <HoldingsComparisonHeader />
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <div className="container mx-auto px-4 py-2">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2">
            <TabsTrigger value="comparison" className="flex items-center gap-2">
              <GitCompare className="h-4 w-4" />
              Period Comparison
            </TabsTrigger>
            <TabsTrigger value="currency-trends" className="flex items-center gap-2">
              <TrendingUp className="h-4 w-4" />
              Currency Trends
            </TabsTrigger>
          </TabsList>
        </div>

        <TabsContent value="comparison" className="mt-0">
          <HoldingsComparisonView
            primaryPeriod={controller.primaryPeriod}
            secondaryPeriod={controller.secondaryPeriod}
            primaryHoldings={controller.primaryHoldings}
            secondaryHoldings={controller.secondaryHoldings}
            comparisonData={controller.comparisonData}
            isLoading={controller.isLoading}
            onSelectPrimaryPeriod={controller.setPrimaryPeriod}
            onSelectSecondaryPeriod={controller.setSecondaryPeriod}
            onClearSecondaryPeriod={controller.clearSecondaryPeriod}
            searchQuery={controller.searchQuery}
            setSearchQuery={controller.setSearchQuery}
          />
        </TabsContent>

        <TabsContent value="currency-trends" className="mt-0">
          <MultiPeriodCurrencyView />
        </TabsContent>
      </Tabs>
    </div>
  );
}; 